/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef, useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import {
  CloudDownloadOutlined,
  CloudUploadOutlined,
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { longanUpdateConfig } from 'longan-sdk';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Layout, Avatar, Menu, Dropdown, Select, Modal, Tooltip, Button } from 'antd';
import { withRouter } from 'react-router-dom';
import useUrlState from '@ahooksjs/use-url-state';
import moment from 'moment';
import cookies from 'js-cookie';
import { initGlobalState } from 'qiankun';
import ModifyPassModal from '../component/ModifyPassModal/index';
import LogModal from '@/components/LogModal/index';
import { setStationID, getStationID, setStationCode, getStationCode } from '@/utils/cookie';
import Api from '../js/api';
import styles from './index.module.less';
import eventEmitter from '@/utils/eventEmitter';
import Notice from './notice';
import download from '../../utils/downloadFile';
import helpIcon from '../../assets/help.svg';

// 初始化-主/微应用通信
const actions = initGlobalState({ stationID: '' });
let timer = null;

const {
  getList,
  getLoginInfo,
  getMyAuth,
  getImportList,
  getImportNewsNum,
  getExportNewsNum,
  getProjectList,
  getBasicData,
} = Api;
const { Header } = Layout;
const { Option } = Select;
const confirm = Modal.confirm;

// 头像下拉
const menu = (props) => {
  const { history, setIsModifyPassModalShow, accountInfo } = props;
  const logout = () => {
    confirm({
      title: '退出登录',
      content: '您确认要退出当前登录吗?',
      async onOk() {
        history.push('/logout');
      },
      onCancel() {},
      prefixCls: 'smart-modal',
      okButtonProps: {
        prefixCls: 'smart-btn',
      },
      cancelButtonProps: {
        prefixCls: 'smart-btn',
      },
    });
  };
  return (
    <Menu>
      {accountInfo.source === 1 ? (
        <Menu.Item key="1" onClick={() => setIsModifyPassModalShow(true)}>
          <SettingOutlined />
          修改密码
        </Menu.Item>
      ) : null}
      <Menu.Item key="2" onClick={logout}>
        <LogoutOutlined />
        退出登录
      </Menu.Item>
    </Menu>
  );
};

const Head = (props) => {
  const {
    dispatch,
    history,
    accountInfo: { accountName, source },
  } = props;
  // 修改密码modal显示
  const [isModifyPassModalShow, setIsModifyPassModalShow] = useState(false);
  // 关闭修改密码modal
  const handleModifyPassModalClose = () => setIsModifyPassModalShow(false);
  // 下载modal
  const [isShow, setIsShow] = useState(false);
  const [isImportShow, setIsImportShow] = useState(false);
  const [logModalData, setLogModalData] = useState([]);
  const [importModalData, setImportModalData] = useState([]);
  const [logData, setLogData] = useState({
    page: 1,
    pageSize: 50,
    total_num: null,
  });
  const [importRequestData, setImportRequestData] = useState({
    page: 1,
    pageSize: 50,
    total_num: null,
  });
  const [importResult, setImportResult] = useState(0);
  const [exportResult, setExportResult] = useState(0);
  const [isDataMask, setIsDataMask] = useState(1);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  // 判断站点是否在其他tab被切换的轮询
  const textRef = useRef();
  // 判断弹框是否弹出，已弹出则不必在弹
  const [isShowCheckStationModal, setShowCheckStationModal] = useState(false);
  const [currentStation, setCurrentStation] = useState(null);
  useLayoutEffect(() => {
    textRef.current = { selectStationId: currentStation, hasShow: isShowCheckStationModal }; // 将 text 写入到 ref
  });

  useEffect(() => {
    timer = setInterval(() => {
      const cookieStationId = getStationID('op_station_id');
      const { selectStationId, hasShow } = textRef.current;
      if (cookieStationId && !hasShow && String(cookieStationId) !== String(selectStationId)) {
        setShowCheckStationModal(true);
        Modal.confirm({
          title: '当前站点已在别处被切换',
          content:
            '点击下方【保留】按钮会继续停留在当前页面的站点中；点击【切换】按钮，将切换至最新站点，但若当前页面存在未保存的数据，则会丢失',
          cancelText: '保留',
          okText: '切换',
          onOk() {
            window.location.reload();
          },
          onCancel() {
            setStationID(textRef.current.selectStationId);
            setShowCheckStationModal(false);
          },
        });
      }
    }, 10000);
    return () => clearInterval(timer);
  }, []);
  const [state, setState] = useUrlState();

  useEffect(() => {
    if (accountName) {
      longanUpdateConfig({
        loginUser: accountName,
      });
    }
  }, [accountName]);
  // 获取子项目列表
  const getSonList = async (stationId) => {
    const res = await getProjectList({ op_station_id: stationId });
    const projectListMap = res.map(({ projectCode, projectName }) => ({
      value: projectCode,
      label: projectName,
    }));
    dispatch({ type: 'GET_PROJECT_MAP', payload: projectListMap });
  };
  // 每分钟获取一次下载和上传列表有没有新增的未读信息
  useEffect(() => {
    // const dataMask = cookies.get('DATA_MASK');
    cookies.set('DATA_MASK', 1);
    setIsDataMask(1);
    const unlisten = props.history.listen((route) => {
      cookies.set('DATA_MASK', 1);
      setIsDataMask(1);
    });
    // if (dataMask === undefined) {
    //   cookies.set('DATA_MASK', 1);
    // } else if (dataMask === '0') {
    //   setIsDataMask(0);
    // } else if (dataMask === '1') {
    //   setIsDataMask(1);
    // }
    setInterval(async () => {
      const importNum = await getImportNewsNum();
      // console.log("🚀 ~ setInterval ~ importNum:", importNum)
      const exportNum = await getExportNewsNum();
      // console.log("🚀 ~ setInterval ~ exportNum:", exportNum)
      setImportResult(importNum);
      setExportResult(exportNum);
    }, 60000);

    return () => {
      unlisten();
    };
  }, []);
  // 打开下载列表
  const showExportList = async () => {
    const { dataList = [], totalCount = 0 } = await getList({ ...logData });
    setExportResult(0);
    setLogModalData(dataList);
    setLogData({ ...logData, total_num: totalCount });
    setIsShow(true);
  };
  // 打开上传列表
  const showImportList = async () => {
    const { dataList = [], totalCount = 0 } = await getImportList({ ...importRequestData });
    setImportResult(0);
    setImportModalData(dataList);
    setImportRequestData({ ...importRequestData, total_num: totalCount });
    setIsImportShow(true);
  };
  // 下载信息
  const emitLogData = async (arg) => {
    const params = {
      ...logData,
      ...arg,
    };
    const { dataList = [] } = await getList({ ...params });
    setLogData({ ...params });
    setLogModalData(dataList);
  };
  // 上传信息
  const emitImportRequestData = async (arg) => {
    const params = {
      ...importRequestData,
      ...arg,
    };
    const { dataList = [] } = await getImportList({ ...params });
    setImportRequestData({ ...params });
    setImportModalData(dataList);
  };
  // 切换仓库获取权限列表
  const getAuth = useCallback(
    async (parm, code) => {
      // 仓库不相同设置新的localstorage存储仓库
      if (String(parm) !== getStationID('op_station_id')) {
        // localStorage.removeItem('op_station_id');
        // 设置session中当前仓库的id
        setStationID(parm);
        actions.setGlobalState({ stationID: parm });
      }
      if (String(code) !== getStationCode()) {
        setStationCode(code);
      }
      // 获取权限列表
      const { authList = {}, projectList = [] } = await getMyAuth();
      // if (
      //   auth_list.site?.worker?.level?.view === 1 ||
      //   auth_list.site?.worker?.staff?.view === 1 ||
      //   auth_list.site?.worker?.position?.view === 1
      // ) {
      //   auth_list.site.worker.view = 1;
      // }
      // 跟新redux中的权限列表
      dispatch({ type: 'INIT_LOADING', payload: false }); // 页面加载loading隐藏
      dispatch({ type: 'GET_AUTH_LIST', payload: authList }); // 权限列表
      dispatch({ type: 'GET_PROJECT_LIST', payload: projectList }); // 权限列表
      // dispatch({
      //   type: 'GET_MENU_LIST',
      //   payload: {
      //     menuList: generateMenu(
      //       auth_list,
      //       isIncludesHelpPage(history.location.pathname, HelpMenus),
      //     ),
      //   },
      // }); // 根据权限列表获取导航目录
    },
    [dispatch],
  );
  const [stationList, setStationList] = useState([]);
  // 初始化仓库
  useEffect(() => {
    async function load() {
      const data = await getLoginInfo();
      dispatch({ type: 'GET_LOGIN_INFO', payload: data });
      // 获取登录信息 & 设置默认仓库
      if (data.stationList.length) {
        // 设置仓库列表
        setStationList(data.stationList);
        // 查看localstorage是否有仓库
        const loacalStationId = getStationID('op_station_id');
        // 查看是否能找到localstorage仓库
        const beforeStation = data.stationList.find(
          (item) => String(item.stationId) === String(loacalStationId),
        );
        let defaultStation;
        // 有此仓库且还有权限
        if (loacalStationId && beforeStation) {
          defaultStation = beforeStation;
        } else {
          // 获取默认仓库
          defaultStation = data.stationList.find((item) => item.isDefault === 1);
        }
        if (defaultStation) setCurrentStation(defaultStation.stationId);
        dispatch({ type: 'SET_CURRENT_STATION_INFO', payload: defaultStation });
        dispatch({ type: 'SET_CURRENT_STATION', payload: defaultStation.stationId });
        dispatch({ type: 'CHANGE_STATION_NAME', payload: defaultStation.stationName });
        // 根据默认仓库获取权限
        getAuth(defaultStation.stationId, defaultStation.stationCode);
        getSonList(defaultStation.stationId);
        const basicData = await getBasicData({
          stationId: defaultStation.stationId,
          englishField: 'order_type',
        });
        // 获取全局基础数据接口
        dispatch({ type: 'GET_BASIC_DATA', payload: basicData });
      }
    }
    load();
  }, [dispatch, getAuth, setStationList]);
  // 数据脱敏
  const handleEmitEvent = () => {
    if (isDataMask === 0) {
      setIsDataMask(1);
      cookies.set('DATA_MASK', 1);
    } else if (isDataMask === 1) {
      setIsDataMask(0);
      cookies.set('DATA_MASK', 0);
    }

    eventEmitter.emit('dataMask');
  };
  // 关闭下载modal
  const handleCloseLogModal = () => {
    setIsShow(false);
    setLogData({
      page: 1,
      pageSize: 50,
      total_num: null,
    });
  };
  // 关闭上传modal
  const handleCloseImportModal = () => {
    setIsImportShow(false);
    setImportRequestData({
      page: 1,
      pageSize: 50,
      total_num: null,
    });
  };

  // 下载
  const handleDownload = (url) => {
    const regex = /^(http|https):\/\//;
    if (regex.test(url)) {
      window.location.href = url;
    } else {
      download(url);
    }
  };

  // 切换仓库确认框
  const showConfirm = (stationId, { props: { children } }) => {
    const {
      accountInfo: { stationList },
    } = props;
    const { authGroupId: currentAuthGroup } =
      stationList.find((item) => item.stationId === currentStation) || {};
    const modal = confirm({
      title: '切换仓库',
      content: `是否确认要切换至 ${children}?`,
      async onOk() {
        try {
          const { authList } = await getMyAuth();
          getSonList();
          if (Object.keys(authList).length > 0) {
            // localStorage.removeItem('op_station_id');
            const selectStationInfo = stationList?.find((item) => item.stationId === stationId);

            // 清空url上的参数，因为这个项目切换仓库后组件整体重新渲染了，原因去看路由生成的那块儿
            const newState = {};
            Object.keys(state).forEach((i) => {
              newState[i] = undefined;
            });
            setState(newState);

            // 设置session中当前仓库的id
            setStationID(stationId);
            actions.setGlobalState({ stationID: stationId });

            setCurrentStation(stationId);
            setStationCode(selectStationInfo?.stationCode);

            dispatch({ type: 'SET_CURRENT_STATION_INFO', payload: selectStationInfo });
            dispatch({ type: 'SET_CURRENT_STATION', payload: stationId });
            dispatch({ type: 'CHANGE_STATION_NAME', payload: children });

            const basicData = await getBasicData({
              stationId: stationId,
              englishField: 'order_type',
            });
            // 获取全局基础数据接口
            dispatch({ type: 'GET_BASIC_DATA', payload: basicData });

            // 直接更新redux中的权限列表
            dispatch({ type: 'GET_AUTH_LIST', payload: authList });

            // 改变仓库获该仓库下的权限列表
            const { authGroupId: nextAuthGroup } =
              stationList.find((item) => item.stationId === stationId) || {};

            if (currentAuthGroup !== nextAuthGroup) {
              history.push('/');
              // 跟新redux中的权限列表
              // dispatch({ type: 'GET_AUTH_LIST', payload: auth_list });
              // dispatch({
              //   type: 'GET_MENU_LIST',
              //   payload: {
              //     menuList: generateMenu(
              //       auth_list,
              //       isIncludesHelpPage(history.location.pathname, HelpMenus),
              //     ),
              //   },
              // });
              dispatch({ type: 'CHANGE_PATH', payload: ['/'] });
              dispatch({ type: 'SELECT_PATH', payload: ['/'] });
            }
          }
        } catch (error) {
          console.log('error: ', error);
        }
      },
      onCancel() {},
      prefixCls: 'smart-modal',
      okButtonProps: {
        prefixCls: 'smart-btn',
      },
      cancelButtonProps: {
        prefixCls: 'smart-btn',
      },
    });
  };

  // 上传modal table
  const importColumns = () => [
    {
      title: '上传时间',
      dataIndex: 'createTime',
      width: 120,
      render: (_, row) => moment(row.createTime * 1000).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      title: '文件名',
      dataIndex: 'fileName',
    },
    {
      title: '上传成功数量',
      dataIndex: 'successCount',
      width: 110,
      render: (_, row) => `${row.successCount}(更新${row.updateCount}条)`,
    },
    {
      title: '上传失败数量',
      dataIndex: 'failedCount',
      width: 110,
    },
    {
      title: '状态',
      dataIndex: 'status',
      width: 80,
      render: (_, row) => {
        const { status } = row;
        switch (String(status)) {
          case '0':
            return '待执行';
          case '1':
            return '执行中';
          case '2':
            return '执行成功';
          case '3':
            return '部分成功';
          case '4':
            return '全部失败';
          default:
            return '-';
        }
      },
    },
    {
      title: '错误概述',
      dataIndex: 'errorReason',
      width: 180,
      render: (_, row) => {
        const { failedDesc } = row;
        const { error_msg, url } = JSON.parse(failedDesc || '{}');
        if (error_msg || url) {
          return (
            <>
              <span>{error_msg}</span>
              {url && (
                // <div>
                //   <a
                //     target="_blank"
                //     // href={`/api/ui/common/downloadfile?file_url=${btoa(encodeURIComponent(url))}`}
                //     href={url}
                //   >
                //     下载错误文件
                //   </a>
                // </div>
                <Button type="link" onClick={() => handleDownload(url)}>
                  下载错误文件
                </Button>
              )}
            </>
          );
        }
        return '';
      },
    },
  ];

  // 下载modal table
  const logColumns = () => [
    {
      title: '创建时间',
      dataIndex: 'createTime',
      width: 60,
      render: (_, row) => moment(row.createTime * 1000).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      title: '下载内容',
      dataIndex: 'exportName',
      width: 130,
    },
    {
      title: '下载状态',
      dataIndex: 'statusName',
      width: 60,
      render: (_, row) => {
        const { status, downloadUrl } = row;
        switch (Number(status)) {
          case 0:
            return '待导出';
          case 1:
            return '导出中';
          case 2:
            return (
              <Button
                type="link"
                // href={`/api/ui/common/downloadfile?file_url=${btoa(
                //   encodeURIComponent(downloadUrl),
                // )}`}
                // href={downloadUrl}
                onClick={() => handleDownload(downloadUrl)}
              >
                点击下载
              </Button>
            );
          case 3:
            return '导出失败';
          default:
            return '--';
        }
      },
    },
  ];

  const isDark = () => {
    const themeColor = cookies.get('themeColor');
    const thePath = props.location.pathname;
    if (themeColor === 'dark' && thePath === '/') {
      return true;
    }
    return false;
  };

  const goHelp = () => {
    window.open(`${window.location.origin}/help/question`, '_blank');
  };

  const handleOpenFaq = () => {
    props.history.push('/faq');
  };

  return (
    <Header className={isDark() ? styles.headwarp_dark : styles.headwarp}>
      <div
        className={'logo'}
        onClick={() => {
          window.location.href = '/';
        }}
        role="presentation"
      />
      <div>
        <Dropdown overlay={menu({ ...props, setIsModifyPassModalShow })}>
          <span className="headIcon">
            <Avatar icon={<UserOutlined />} />
            <span className="headIcon_name">
              {accountName} ({source === 1 ? 'DB' : 'AD'})
            </span>
          </span>
        </Dropdown>
        <Tooltip placement="bottom" title="上传列表">
          <span className="headIcon">
            <CloudUploadOutlined className="headIcon_up" onClick={() => showImportList()} />
            <div
              className="point"
              style={Number(importResult) === 0 ? { display: 'none' } : { display: 'block' }}
            />
          </span>
        </Tooltip>
        <Tooltip placement="bottom" title="下载列表">
          <span className="headIcon">
            <CloudDownloadOutlined className="headIcon_down" onClick={() => showExportList()} />
            <div
              className="point"
              style={Number(exportResult) === 0 ? { display: 'none' } : { display: 'block' }}
            />
          </span>
        </Tooltip>
        <span className="headIcon" style={{ margin: '0 8px' }}>
          <Notice />
        </span>
        <span className="headIcon">
          <Select
            className="headIcon_select"
            // style={{ maxWidth: '300px' }}
            onDropdownVisibleChange={(p) => {
              setDropdownVisible(p);
            }}
            style={dropdownVisible ? { width: '300px' } : { maxWidth: '300px' }}
            value={currentStation}
            showSearch
            optionFilterProp="children"
            onChange={showConfirm}
          >
            {stationList.map((item) => {
              if (item.stationId) {
                return (
                  <Option key={item.stationId} title={item.stationName} value={item.stationId}>
                    {item.stationName}
                  </Option>
                );
              }
              return null;
            })}
          </Select>
        </span>
        <span style={{ paddingTop: 3 }} className="headIcon" onClick={handleEmitEvent}>
          <LegacyIcon className="dataSensitive" type={isDataMask ? 'eye-invisible' : 'eye'} />
        </span>
        <span
          onClick={() => handleOpenFaq()}
          className="headIcon"
          style={{
            margin: '0 8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              width: 20,
              height: 20,
              backgroundSize: '100% 100%',
              backgroundImage: `url(${helpIcon})`,
            }}
          />
        </span>
      </div>
      {/* <span className="headIcon" onClick={goHelp}>
        <Icon className="dataSensitive" type="question-circle" />
      </span> */}
      <LogModal
        isShowLogModal={isShow}
        logTitle="下载列表"
        logColumns={logColumns()}
        handleCloseLogModal={handleCloseLogModal}
        logModalData={logModalData}
        logData={logData}
        emitLogData={emitLogData}
      />
      <LogModal
        width={800}
        isShowLogModal={isImportShow}
        logTitle="上传列表"
        logColumns={importColumns()}
        handleCloseLogModal={handleCloseImportModal}
        logModalData={importModalData}
        logData={importRequestData}
        emitLogData={emitImportRequestData}
      />
      <ModifyPassModal
        isModifyPassModalShow={isModifyPassModalShow}
        handleModifyPassModalClose={handleModifyPassModalClose}
      />
    </Header>
  );
};

const mapStateToProps = (state) => {
  const { basic } = state;
  return {
    ...basic,
  };
};

export default connect(mapStateToProps)(withRouter(Head));
